import { useState, useEffect } from 'react'; 
import { NotificationService } from '../service/NotificationService';
import { storageMng } from '../helper/StorageMng';
import { NotificationItemModel } from '../generated/api';
import { useNavigate } from 'react-router-dom';
import { useCurrUserUtility } from './useCurrUserUtility';

export const useNotificationManager = () => {
  const { isAuth, getCurrUserToken } = useCurrUserUtility();
  const [notifications, setNotifications] = useState<NotificationItemModel[]>(() => {
    const sessionData = storageMng.getItem("notificationItems");
    return sessionData ? JSON.parse(sessionData) : [];
  });
  const navigate = useNavigate();
  
  useEffect(() => {
    storageMng.setItem("notificationItems", JSON.stringify(notifications));
  }, [notifications]);

  useEffect(() => {
    const fetchData = async () => {
      if (!isAuth()) return;
      const notificationService=new NotificationService( navigate); 
      const fetchedNotifications = await notificationService.GetNotifications();
      setNotifications(fetchedNotifications);
    };
    fetchData();
  }, []);

  const add = (item: NotificationItemModel) => {
    setNotifications(prev => [...prev, item]);
  };

  const remove = (token: string) => {
    setNotifications(prev => prev.filter(notification => notification.token !== token));
  };

  const setAsSeen = (notificationToken: string) => {
    setNotifications(prev => prev.map(notification =>
      notification.token === notificationToken ? { ...notification, isSeen: true } : notification
    ));
  };

  return { notifications, add, remove, setAsSeen };
};
